<template>
	<v-container>
		<v-row v-if="error">
			<v-col cols="12" sm6 offset-sm3>
				<app-alert @dismissed="onDismissed" class="error" :text="error.message"></app-alert>
			</v-col>
		</v-row>
		<v-row >
			<v-col cols="12">
				<v-card>
					<v-card-text>
						<v-container>
							<v-form 
							ref="form"
							v-model="valid"
							lazy-validation
							@submit.prevent="onSignup"
							>
							<v-row>
								<v-col cols="12" sm="6">
									<v-text-field
									text-capitalize
									name="first name"
									label="First Name"
									id="singUpFirstName"
									v-model="user.firstName"
									type="text"
									required>
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
								text-capitalize
								name="last name"
								label="Last Name"
								id="singUpLastName"
								v-model="user.lastName"
								type="text"
								required></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
								name="email"
								label="Email"
								id="singUpEmail"
								v-model="user.email"
								type="email"
								:rules="emailRules"
								required></v-text-field>
							</v-col>

							<v-col cols="12" sm="6">
								<v-text-field
								name="password"
								label="Password"
								id="singUpPassword"
								v-model="user.password"
								type="password"
								required></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
								name="confirmPassword"
								label="Confirm Password"
								id="confirmPassword"
								v-model="confirmPassword"
								type="password"
								:rules="comparePasswords"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-checkbox label="Check If You Have A Company Key Id" v-model="haveKey"></v-checkbox>
							</v-col>
							<v-col cols="12" sm="6" v-if="haveKey">
								<v-text-field
								name="companyId"
								label="Company Key Id"
								id="companyId"
								v-model="user.cId"
								placeholder="Collaboration Key"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6" v-if="haveKey">
								<v-select
								:items="services"
								v-model="user.service"
								label="Technical/Service Trade"
								></v-select>
							</v-col>

							<v-col cols="12">
								<v-btn class="primary" type="submit" :disabled="!valid" :loading="loading">
									Sign up
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</v-card-text>
		</v-card>
	</v-col>
</v-row>
</v-container>
</template>

<script>
export default {
	data () {
		return {
			valid: true,
			haveKey: false,   
			user: {
				firstName: '',
				lastName: '',
				email: '',
				cId: '',
				service: '',
				password: ''
			},
			emailRules: [
			v => !!v || 'E-mail is required',
			v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
			],
			services: [ 'HVAC',
			'ELECTRICAL',
			'PLUMBING',
			'DRAINS',
			'SOLAR'
			],
			confirmPassword: '',
			comparePasswords: [
			v => v == this.user.password || 'Passwords do not match' 
			]
		}
	},
	computed: {
		User () {
			return this.$store.getters.user
		},
		error () {
			return this.$store.getters.error
		},
		loading () {
			return this.$store.getters.loading
		}
	},
	watch: {
		User (value) {
			if (value !== null && value !== undefined) {
				// this.$router.push('/options')
			}
		}
	},
	methods: {
		onSignup () {
			this.user.cId.length > 0 
			? this.$store.dispatch('validateKey', {...this.user, callBack: 'signUserUp'}) 
			: this.$store.dispatch('signUserUp', this.user)

		},
		onDismissed () {
			this.$store.dispatch('clearError')
		}

	}
}
</script>
